export default "__VITE_ASSET__Dr21u62n__"